import React from 'react';

function SelfPacedHeader({ type }) {
  return (
    <div className="d-flex pt-4 pb-3 w-100 justify-content-center sticky-top bg-light">
      {type.endsWith('competencies') ? (
        <h1 className="display-1">Competencies</h1>
      ) : (
        <h1 className="display-1">Work Preferences</h1>
      )}
    </div>
  );
}

export default SelfPacedHeader;
